export default class TipoProjeto {

  constructor(
    IdTipoProjeto = null,
    Descricao = '',
    Status = 'A'
  ) {
    this.IdTipoProjeto = IdTipoProjeto;
    this.Descricao = Descricao;
    this.Status = Status;
  }
  
}